module.exports = __webpack_public_path__ + "img/icon_map_2_yj_hg_c.9794d40e.png";